import type { ChatScrollAnchor } from './chat-scroll-anchor';

export type ChatScrollMemory =
  | { kind: 'bottom' }
  | ({ kind: 'anchor' } & ChatScrollAnchor);

const positions = new Map<string, ChatScrollMemory>();

export function rememberChatScrollPosition({
  sessionId,
  position,
}: {
  sessionId: string;
  position: ChatScrollMemory;
}): void {
  positions.set(sessionId, position);
}

export function readChatScrollPosition(
  sessionId: string,
): ChatScrollMemory | undefined {
  return positions.get(sessionId);
}

export function clearChatScrollPosition(sessionId: string): void {
  positions.delete(sessionId);
}
